/**
 * Created by razial on 26.05.2025.
 */

const WordsoupMapSaver = {
    loadUnit: function (map2d, x, y, fakeUnits) {
        if (!map2d._storedUnits) {
            map2d._storedUnits = map2d.slot.load("units") || {};
        }

        const fakeUnit = fakeUnits[x] && fakeUnits[x][y];
        if (fakeUnit) {
            const saveUnit = map2d._storedUnits[fakeUnit.code];
            if (saveUnit) {
                return { code: fakeUnit.code, ...saveUnit };
            } if (Families[fakeUnit.code || fakeUnit.head.code].units[0].invisible
                || Families[fakeUnit.code || fakeUnit.head.code].type === "soon"
            ) {
                return fakeUnit;
            }
        }
    },

    saveUnit: function (map2d, x, y, info) {
        const data = {};

        data.stage = info.stage;

        if (info.choice !== undefined) {
            data.choice = info.choice;
        }

        map2d._storedUnits[info.code] = data;

        map2d.slot.save("units", map2d._storedUnits);
    },

    removeUnit: function (map2d, x, y, unit) {
        const saveUnit = map2d._storedUnits[unit.code];
        if (saveUnit) {
            delete map2d._storedUnits[unit.code];

            map2d.slot.save("units", map2d._storedUnits);
        }
    }
};
